export default __webpack_public_path__ + "static/media/legalHeirImg.f1e75f92.svg";